// extracted by mini-css-extract-plugin
export default {"betLimits":"fn_fo","betLimits_mobile_title":"fn_fp","betLimits__footer":"fn_fq"};